import { COUPONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import couponsTypes from '../../constants/couponsTypes'
import { axios } from '../../services'

//  RESET CAMPAIGN TOKEN
const reset_campaign_token_request = () => {
  return {
    type: couponsTypes.reset_token.request
  }
}

const reset_campaign_token_success = (response) => {
  return {
    type: couponsTypes.reset_token.success,
    payload: response.data
  }
}

const reset_campaign_token_failure = (messages) => {
  if (messages.constructor === Array) {
    window.showSnackbar('error', messages.join("\n"))
  }
  return {
    type: couponsTypes.reset_token.failure,
    payload: messages
  }
}

const reset_campaign_token = (coupon_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( reset_campaign_token_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(COUPONS_ROUTES.reset_token, {id: coupon_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The Campaign Token has been reset.')
      if ( index ) {
        dispatch( reset_campaign_token_success(response) )

      } else {
        dispatch( reset_campaign_token_failure(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error resetting campaign token"]
      }
      dispatch( reset_campaign_token_failure( errors ) )
    })
  }
}

export {
  reset_campaign_token,
}



// WEBPACK FOOTER //
// ./src/js/actions/coupons/reset_token.js